export default "__VITE_ASSET__D6I3uxCK__"